import { create } from 'zustand';
import { SuperAdminCatalogFilterState } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

const DEFAULT_PAGE_SIZE = 10;

const createDefaultFilter = (): SuperAdminCatalogFilterState => ({
    take: DEFAULT_PAGE_SIZE,
    skip: 0,
    tenantId: null,
    ownerId: null,
    searchText: null,
    orderBy: null,
    orderDirection: 'asc',
});

type OwnersFilterStore = {
    filter: SuperAdminCatalogFilterState;
    setFilter: (filter: Partial<SuperAdminCatalogFilterState>) => void;
    resetFilter: () => void;
};

export const useSuperAdminOwnersFilter = create<OwnersFilterStore>((set) => ({
    filter: createDefaultFilter(),
    setFilter: (newFilter) => {
        set((state) => ({
            filter: {
                ...state.filter,
                ...newFilter,
            },
        }));
    },
    resetFilter: () => {
        set({ filter: createDefaultFilter() });
    },
}));
